package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_05_10_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-05-10")
@Composable
public fun Log_2025_05_10(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The call is coming from inside the house",
        ogTitle = "The call is coming from inside the house",
        date = LocalDate(2_025, 5, 10),
        aiHint = "Title & description are a joke",
        ogDescription = "Tuesday had long feared Hags. He nervously scouted the dark corners of the woods and swamps as the heroes traveled throughout Veldekar. Little did he know, Korvis was “harboring” a Sea Hag.",
        ogImage = "ai/2025-05-10.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "shimmer-5", dateString = "Shimmer 5")
        Log_2025_05_10_Day_1()
    }
}
